import React from 'react';

const HostName = () => {
  return <span>rot@spacehost:~# </span>;
};

export default HostName;